import { useMemo } from 'react';
export const useDescribers = ({ help, uniqueId, guidance }) => useMemo(() => {
    if (uniqueId && (help || guidance)) {
        return `${help ? uniqueId + '-help' : ''} ${guidance ? uniqueId + '-guidance' : ''}`;
    }
    return undefined;
}, [guidance, help, uniqueId]);
